import React from 'react';
import './PetAnimations.css';

export default function BeeSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F0C830';
  const lightColor = color ? lighten(color) : '#F8DC68';
  const darkColor = color ? darken(color) : '#C0A010';
  const stripeColor = '#2A2A2A';
  const wingColor = 'rgba(200, 220, 255, 0.5)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Wings */}
      <ellipse cx="42" cy="38" rx="16" ry="10" fill={wingColor} stroke="rgba(160,190,230,0.6)" strokeWidth="0.8" />
      <ellipse cx="72" cy="38" rx="16" ry="10" fill={wingColor} stroke="rgba(160,190,230,0.6)" strokeWidth="0.8" />
      {/* Antennae */}
      <path d="M50 40C48 32 44 26 40 24" stroke={stripeColor} strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <circle cx="39" cy="23" r="2.5" fill={stripeColor} />
      <path d="M66 40C68 32 72 26 76 24" stroke={stripeColor} strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <circle cx="77" cy="23" r="2.5" fill={stripeColor} />
      {/* Body */}
      <ellipse cx="58" cy="60" rx="24" ry="22" fill={bodyColor} />
      {/* Fuzzy texture */}
      <ellipse cx="58" cy="56" rx="22" ry="18" fill={lightColor} opacity="0.4" />
      {/* Stripes */}
      <rect x="36" y="52" width="44" height="5" rx="2" fill={stripeColor} opacity="0.85" />
      <rect x="38" y="62" width="40" height="5" rx="2" fill={stripeColor} opacity="0.85" />
      <rect x="42" y="72" width="32" height="5" rx="2" fill={stripeColor} opacity="0.85" />
      {/* Face */}
      <ellipse cx="58" cy="48" rx="14" ry="10" fill={lightColor} />
      {/* Eyes */}
      <circle cx="52" cy="46" r="3.5" fill="white" />
      <circle cx="64" cy="46" r="3.5" fill="white" />
      <circle cx="53" cy="46" r="2" fill="#1A1A1A" />
      <circle cx="65" cy="46" r="2" fill="#1A1A1A" />
      <circle cx="53.5" cy="45" r="0.8" fill="white" />
      <circle cx="65.5" cy="45" r="0.8" fill="white" />
      {/* Mouth - happy smile */}
      <path d="M54 52C56 54 60 54 62 52" stroke={stripeColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Stinger */}
      <path d="M58 82L56 88L60 88Z" fill={darkColor} />
      {/* Legs */}
      <line x1="44" y1="72" x2="38" y2="82" stroke={stripeColor} strokeWidth="1.5" strokeLinecap="round" />
      <line x1="50" y1="76" x2="46" y2="86" stroke={stripeColor} strokeWidth="1.5" strokeLinecap="round" />
      <line x1="66" y1="76" x2="70" y2="86" stroke={stripeColor} strokeWidth="1.5" strokeLinecap="round" />
      <line x1="72" y1="72" x2="78" y2="82" stroke={stripeColor} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
